export default {
      id: "star-outline-usage",
      viewBox: "0 0 768 768",
      url: __webpack_public_path__ + "img/icons.792d8a78.svg#star-outline-usage",
      toString: function () {
        return this.url;
      }
    }